import { render, staticRenderFns } from "./FilterNeedFriend.vue?vue&type=template&id=1ee30163&scoped=true&"
import script from "./FilterNeedFriend.vue?vue&type=script&lang=js&"
export * from "./FilterNeedFriend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee30163",
  null
  
)

export default component.exports